var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackspace = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5,2L0,7.5L5,13h11V2H5z M12.21,8.79c0.39,0.39,0.39,1.03,0,1.42c-0.19,0.19-0.44,0.29-0.71,0.29 c-0.27,0-0.52-0.1-0.71-0.29L9.5,8.91l-1.29,1.3c-0.38,0.37-1.04,0.37-1.42,0c-0.39-0.39-0.39-1.03,0-1.42l1.3-1.29l-1.3-1.29 c-0.39-0.39-0.39-1.03,0-1.42c0.39-0.39,1.03-0.39,1.42,0l1.29,1.3l1.29-1.3c0.39-0.39,1.03-0.39,1.42,0c0.39,0.39,0.39,1.03,0,1.42 l-1.3,1.29L12.21,8.79z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackspace);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/backspace.9a95a31f54add4b15660298fdaf7e45f.svg";